import { showPaymentProcessingPopupAction } from "@src/components/BottomSheets/store/actions";
import { getAwsAssets } from "@src/utils";
import { t } from "i18next";
import { Image } from "@src/components/Image";
import React from "react";
import { useDispatch } from "react-redux";
import { toggleRecentActivitySuggestions } from "../../../BottomSheets/store/actions";
import Popup from "@src/components/UIElements/Popup";

import style from "./PaymentProcessing.module.scss";

function PaymentProcessingPopup() {
  // DISPATCH
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(showPaymentProcessingPopupAction(false));
  };
  return (
    <Popup handleClose={handleClose}>
      <div className={style.RemoveSuggestions}>
        <Image
          src={getAwsAssets("clockIcon.svg", "bottomSheets")}
          width="48px"
          height="48px"
          alt={t(
            "components.bottomSheets.components.expirySoonBottomSheet.clockIcon",
            "ClockIcon"
          )}
        />

        <h2>Payment is in Process</h2>
        <p>
          Your payment is currently being processed with your bank. Please wait
          for sometime.
        </p>

        <button onClick={handleClose}>OKAY</button>
      </div>
    </Popup>
  );
}

export default PaymentProcessingPopup;
